import { useQuery } from "@tanstack/react-query";
import { usePrevious } from "react-use";
import api from "../api";
import { prependHttpToUrl } from "../util";

export const URL_ANALYSIS_STATUS = "urlAnalysisStatus";

const REFETCH_INTERVAL_SECONDS = 2 * 1000;

const useUrlAnalysisStatus = (url: string) => {
  const validUrl = prependHttpToUrl(url);
  const { data, refetch, isFetching, isSuccess } = useQuery({
    queryKey: [URL_ANALYSIS_STATUS, validUrl],
    queryFn: ({ signal }) => api.getAnalysisStatus(validUrl, signal),
    enabled: Boolean(validUrl),
    select: ({ data: response }) => response,
    refetchInterval: ({ state }) => {
      const { data: { data: response = undefined } = {} } = state ?? {};
      if (!response?.is_analyzing) return false;
      return REFETCH_INTERVAL_SECONDS;
    }
  });

  const prevData = usePrevious(data);
  const prevIsFetching = usePrevious(isFetching);

  const isAnalyzing = data?.is_analyzing ?? false;
  const wasAnalyzing = prevData?.is_analyzing;

  const didTransition = wasAnalyzing && !isAnalyzing;

  const finishedFirstLoad =
    prevIsFetching && !isFetching && isSuccess && !prevData && !isAnalyzing;

  const isFinished = didTransition || finishedFirstLoad;

  return { refetch, isFinished, isAnalyzing };
};

export default useUrlAnalysisStatus;
